// extracted by mini-css-extract-plugin
module.exports = {"text":"_7a3fb80146--text--Evko1"};